import { render, staticRenderFns } from "./ConnectFail.vue?vue&type=template&id=8ef60ef2&scoped=true&"
import script from "./ConnectFail.vue?vue&type=script&lang=js&"
export * from "./ConnectFail.vue?vue&type=script&lang=js&"
import style0 from "./ConnectFail.vue?vue&type=style&index=0&id=8ef60ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef60ef2",
  null
  
)

export default component.exports